<template>
<div>
  <loading :active.sync="loading"></loading>
  <div class="jumbotron">
    <div class="row">
      <h4>Get Noticed!</h4>
    </div>
    <div v-if="!adminComplete" class="row">
      <router-link to="/profile/business/contacts">
        <b-alert variant="info" show>In order to purchase prioritized search results you must first fill out your administrator credentials.</b-alert>
      </router-link>
    </div>
    <div class="row">
      <div class="col">
        <p>Want to move your company to the front of the line? Advertise with HomApt for optimal search listings and start getting qualified leads. Simply choose where you want to advertise and the type of package that will help increase your sales and annual revenues.</p>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-5 my-auto">
        <p>For volume discounts call:<br>(612) 655-2324</p>
      </div>
      <div class="col-lg-7">
        <table class="table-responsive-sm table-bordered">
          <thead>
            <tr>
              <th class="centered-table-content" scope="col"># of Zips Included</th>
              <th class="centered-table-content" scope="col">Price/Month BASIC</th>
              <th class="centered-table-content" scope="col">Price/Month PRO</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="zipPackage in zipPackages" :key="zipPackage.key">
              <td class="centered-table-content">{{ zipPackage.size }}</td>
              <td class="centered-table-content">${{ zipPackage.basic }}</td>
              <td class="centered-table-content">${{ zipPackage.pro }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <table class="table-responsive-sm table-bordered">
          <thead>
            <tr>
              <th class="invisible-table" scope="col" style="width:70%"></th>
              <th scope="col" style="width:10%" class="centered-table-content">FREE</th>
              <th scope="col" style="width:10%" class="centered-table-content">BASIC</th>
              <th scope="col" style="width:10%" class="centered-table-content">PRO</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Update business information</td>
              <td class="centered-table-content">&#10003;</td>
              <td class="centered-table-content">&#10003;</td>
              <td class="centered-table-content">&#10003;</td>
            </tr>
            <tr>
              <td>Add photos</td>
              <td class="centered-table-content">&#10003;</td>
              <td class="centered-table-content">&#10003;</td>
              <td class="centered-table-content">&#10003;</td>
            </tr>
            <tr>
              <td>Free coupon clicks per month</td>
              <td class="centered-table-content"></td>
              <td class="centered-table-content">2</td>
              <td class="centered-table-content">5</td>
            </tr>
            <tr>
              <td>Priority display in searches</td>
              <td class="centered-table-content"></td>
              <td class="centered-table-content">&#10003;</td>
              <td class="centered-table-content">&#10003;</td>
            </tr>
            <tr>
              <td>Highest priority display in searches</td>
              <td class="centered-table-content"></td>
              <td class="centered-table-content"></td>
              <td class="centered-table-content">&#10003;</td>
            </tr>
            <tr class="invisible-table">
              <td class="invisible-table"></td>
              <td class="invisible-table"></td>
              <td class="invisible-table">
                <router-link v-if="adminComplete" to="/profile/business/advertising/priority/order">
                  <button class="btn btn-primary" v-on:click="updateProduct('basic')">Select</button>
                </router-link>
              </td>
              <td class="invisible-table">
                <router-link v-if="adminComplete" to="/profile/business/advertising/priority/order">
                  <button class="btn btn-primary" v-on:click="updateProduct('pro')">Select</button>
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="jumbotron">
    <div class="row">
      <h4>Billing and Refund Policy</h4>
    </div>
    <div class="row">
      <div class="col">
        <p>Billing for Subscription Services is completed monthly with the start date of the campaign as the start of the billing cycle. If you discontinue the monthly auto renewal, your advertising campaign will stay active for the remainder of the current period.</p>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapMutations, mapGetters } from 'vuex'

export default {
  data () {
    return {
      loading: false,
      zipPackages: []
    }
  },
  components: {
    Loading
  },
  methods: {
    ...mapMutations('products', [
      'updateProduct'
    ]),
    async getAdvertisingPrices () {
      try {
        var that = this
        var client = this.$store.getters.getPaymentApigClientFactory
        var params = {}
        var pathTemplate = '/advertising'
        var method = 'GET'
        var additionalParams = {}
        var body = {}
        var result = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
        var priceCalculator = result.data.advertising.price_calculator
        for (var i = 0; i < priceCalculator.bundles_size.length; i++) {
          var zipPackage = {
            size: priceCalculator.bundles_size[i],
            basic: priceCalculator.tiers.basic[i],
            pro: priceCalculator.tiers.pro[i]
          }
          that.zipPackages.push(zipPackage)
        }
      } catch (error) {
        console.log(error)
      }
    }
  },
  computed: {
    ...mapGetters('business', [
      'adminComplete'
    ])
  },
  async created () {
    await Promise.all([this.getAdvertisingPrices()])
  }
}
</script>
<style scoped>
.jumbotron {
  background-color: #f1f1f1 !important;
  margin-bottom: 3rem !important;
  border-radius: 25px;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

td {
  background-color: white;
  padding-left: 4px;
  padding-right: 4px;
}

.centered-table-content {
  text-align: center;
}

.btn {
  margin-top: 8px;
}
th {
  background-color: #333333;
  color: #feedaa !important;
}

.table-responsive-sm {
  border: 0px !important;
  margin-bottom: 1rem;
  width: 100%;
}

.invisible-table {
  background-color: #f1f1f1 !important;
  border: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/businessProfile/advertising/priority/subnavItems/Overview.vue